module.exports = __webpack_public_path__ + "img/141.5656de9.png";